export function fmtDate(value) {
    return new Intl.DateTimeFormat(undefined, {
        dateStyle: "medium",
        timeStyle: "short",
    }).format(new Date(value * 1000));
}
export function fmtDateOnly(value) {
    return new Intl.DateTimeFormat(undefined, {
        dateStyle: "medium",
    }).format(new Date(value * 1000));
}
export function displayTitle(title) {
    return title.replace(/\.md$/i, "");
}
export function fmtRelative(value) {
    const diffSeconds = Math.round((value * 1000 - Date.now()) / 1000);
    const abs = Math.abs(diffSeconds);
    const units = [
        ["year", 60 * 60 * 24 * 365],
        ["month", 60 * 60 * 24 * 30],
        ["day", 60 * 60 * 24],
        ["hour", 60 * 60],
        ["minute", 60],
    ];
    const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
    for (const [unit, secondsPerUnit] of units) {
        if (abs >= secondsPerUnit) {
            return formatter.format(Math.round(diffSeconds / secondsPerUnit), unit);
        }
    }
    return formatter.format(diffSeconds, "second");
}
export function fmtCharCount(count) {
    if (count >= 1000000)
        return (count / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    if (count >= 1000)
        return (count / 1000).toFixed(1).replace(/\.0$/, "") + "k";
    return count.toString();
}
export function fmtFileSize(bytes) {
    if (bytes >= 1_000_000)
        return (bytes / 1_000_000).toFixed(1).replace(/\.0$/, "") + " MB";
    if (bytes >= 1_000)
        return (bytes / 1_000).toFixed(1).replace(/\.0$/, "") + " KB";
    return bytes + " B";
}
export function calcDiff(oldText, newText) {
    const oldLen = oldText.length;
    const newLen = newText.length;
    const added = Math.max(0, newLen - oldLen);
    const removed = Math.max(0, oldLen - newLen);
    return { added, removed, net: newLen - oldLen };
}
